import { Axios } from 'src/lib';

import { FronteggContext } from '@frontegg/rest-api';
import {
  legalConfirmationSlice,
  legalConfirmationLoadingSlice,
} from '../slices/legalConfirmation.slice';

export const getLegalConfirmationAction = () => {
  return async (dispatch) => {
    dispatch(legalConfirmationLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    try {
      const result = await Axios.get(`/v2/legal_confirmation/op`, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(legalConfirmationSlice(response));
      }
    } catch (error) {
      console.error('Error fetching legal confirmation:', error);
    } finally {
      dispatch(legalConfirmationLoadingSlice(false));
    }
  };
};

export const updateLegalConfirmationAction = (type) => {
  return async (dispatch) => {
    dispatch(legalConfirmationLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const payload = {
      type: String(type),
    };
    try {
      const result = await Axios.post(`/v2/legal_confirmation/op`, payload, {
        headers,
      });
      if (result?.status === 200) {
        dispatch(getLegalConfirmationAction());
      }
    } catch (error) {
      console.error('Error updating legal confirmation:', error);
    } finally {
      dispatch(legalConfirmationLoadingSlice(false));
    }
  };
};
